import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import ViewsTable from '../../../../components/tables/ViewsTable';
import { UncontrolledTooltip } from 'reactstrap';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';

class ViewTableModal extends React.Component {
    constructor(props) {
        super(props);
        const columns = {
            recipientName: 'Name',
            recipientEmail: 'Email',
            sentAt: 'Sent date',
            delivered: 'Delivered',
            deliveredAt: 'Delivered date',
            open: 'Opened',
            openAt: 'Opened date',
            click: 'Clicked',
            clickAt: 'Clicked date',
            bounce: 'Bounced',
            bounceAt: 'Bounced date',
        };
        const columnTypes = {
            recipientName: 'text',
            recipientEmail: 'text',
            sentAt: 'date',
            delivered: 'boolean',
            deliveredAt: 'date',
            open: 'boolean',
            openAt: 'date',
            click: 'boolean',
            clickAt: 'date',
            bounce: 'boolean',
            bounceAt: 'date',
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });
        this.state = {
            updateResults: null,
            submitting: false,
            invalid: false,
            success: false,
            selectedValue: {},
            requiredFields: {
                selectedValue: false
            },
            editedValues: {},
            columnSearchTerm: '',
            selectedColumns: {},
            activeCategories: [],
            loading: true,
            selectedSection: 0,
            isConfirmation: false,
            removedProperties: {},
            beginningValues: {},
            editedProperties: [],
            columnTypes: columnTypes,
            columns: columns,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            checkedAttendees: {},
            searchTerm: ''
        };
    }

    componentDidMount() {
        const { categoryColumns, selectedView, bannedProperties } = this.props;
        let activeCategories = {};
        let editedValues = {};

        this.setState({ loading: false, activeCategories: Object.keys(activeCategories), beginningValues: editedValues, editedValues: editedValues })
    }
    handleStatusChosen = (e) => {
        this.setState({ selectedValue: e });
    };

    updatedEditedValue = (key, value) => {
        this.setState({ editedValues: { ...this.state.editedValues, [key]: value } });
    }

    submit = async () => {
        const { checkedAttendees } = this.state;

        this.setState({ submitting: true, success: false });
        let selectedAttendeeIds = Object.keys(checkedAttendees);
        let filteredSelectedAttendees = this.props.attendees.filter((attendee) => {
            return selectedAttendeeIds.includes(attendee._id);
        }).map((attendee) => {
            return {
                _id: attendee._id,
                firstName: attendee.firstName,
                lastName: attendee.lastName,
                email: attendee.email,
            };
        });
        this.props.batchUpdateAttendees(filteredSelectedAttendees, () => {
            this.setState({ submitting: false, success: true });
            this.props.toggle();
        });


    };

    updateSelectedSection = (index) => {
        this.setState({ selectedSection: index });
    };

    updatedCheckedAttendees = (checked) => {
        this.setState({ checkedAttendees: checked });
    };
    /* Download */
    s2ab = (s) => {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf); //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
        return buf;
    };
    downloadReport = async () => {
        const { data } = this.props;
        const { editedEmail, columns, columnTypes } = this.state;

        const entries = data; //selectedCustomView ? organizedEntries : allEntries;
        const dataRows = [];
        entries.forEach((entry) => {
            const dataRow = {};
            Object.keys(columns).forEach((hc) => {
                if (entry[hc] != null) {
                    if (columnTypes[hc] === 'boolean' || columnTypes[hc] === 'bool') {
                        dataRow[hc] = entry[hc] ? 'Yes' : 'No';
                    } else {
                        dataRow[hc] = entry[hc];
                    }
                }
            });
            dataRows.push(dataRow);
        });
        const cleanData = [];
        const headers = Object.keys(columns).map((header, hIndex) => {
            dataRows.forEach((data, dIndex) => {
                if (!cleanData[dIndex]) cleanData[dIndex] = [];
                cleanData[dIndex][hIndex] = data[header] || '';
            });
            return columns[header];
        });
        const exportData = {
            headerRow: headers,
            dataRows: cleanData
        };

        const reportDetails =
            { Title: "Report", Subject: 'Email Recipient Report' };
        this.downloadRegular(reportDetails, exportData);
    };

    downloadRegular = (report, data) => {
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: report.Title,
            Subject: report.Subject,
            Author: 'Simple Events',
            CreatedDate: new Date()
        };
        wb.SheetNames.push('Data');
        /* make worksheet */
        var ws_data2 = [data.headerRow, ...data.dataRows];
        var ws2 = XLSX.utils.aoa_to_sheet(ws_data2);

        /* Add the worksheet to the workbook */
        wb.Sheets['Data'] = ws2;

        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        saveAs(
            new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
            `${report.Title}_${moment().format('LLL')}.xlsx`
        );
    };

    searchEntries = (searchText) => {
        this.setState({ searching: searchText != '' ? true : false, searchText: searchText ? searchText : '' });
    };

    render() {
        const {
            isOpen,
            toggle,
            checkedEntries,
            attendees,
            newModalTitle
        } = this.props;

        const {
            submitting,
            success,
            loading,
            isConfirmation,
            editedProperties,
            normalizedColumns,
            toggledColumns,
            selectedColumnSort,
            searchTerm,
            sortDesc,
            columnWidth,
            columns,
            checkedAttendees
        } = this.state;
        let availableAttendees = this.props.data;
        let data = availableAttendees;
        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        if (selectedColumnSort) {
            data = availableAttendees.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            availableAttendees = sortDesc ? availableAttendees.reverse() : availableAttendees;
        }

        return (

            <div>
                {!loading && <FieldModal
                    size="large"
                    isOpen={isOpen}
                    modalTitle={newModalTitle}
                    bodyHeaderText={''}
                    bodyExtraText={''}

                    bodyContent={() => {
                        return (
                            <div className=' flex sectionContainer'>
                                <div className='mb-10  mt-10 flex aic'>
                                    <InputField
                                        classes="m-0 viewSearch"
                                        placeholder="Search "
                                        clickIcon={true}
                                        required={true}
                                        value={searchTerm}
                                        onChange={(e) => {
                                            clearTimeout(this.searchTimeout);
                                            this.setState({ searchTerm: e.target.value },
                                                () => {
                                                    this.searchTimeout = setTimeout(() => this.searchEntries(this.state.searchTerm), 1000);
                                                });

                                        }}
                                        prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                        inputIcon={searchTerm != '' &&
                                            <i
                                                onMouseDown={() => this.setState({ searchTerm: '', searching: false }, () => this.searchEntries(''))}
                                                //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                                className="las la-times-circle"
                                                style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                                            />}
                                    />
                                    <div className="sectionOptionsContainer">
                                        <div id="downloadTable" className='c-pointer fs-20' onClick={() => this.downloadReport()}>
                                            <i className="las la-download" />
                                            <UncontrolledTooltip target="downloadTable" placement="left">Download Table Data</UncontrolledTooltip>
                                        </div>
                                    </div>
                                </div>
                                <ViewsTable
                                    title="Attendees"

                                    classes="h-100"
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={data}
                                    disableCheck={true}
                                    mainColumnActive={false}
                                    columnWidth={columnWidth}
                                    checked={this.state.checkedAttendees}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedAttendees;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.updatedCheckedAttendees(checked);
                                    }}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedAttendees;
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.updatedCheckedAttendees(checked);
                                    }}
                                    sortData={this.sortData}
                                />{' '}
                            </div>
                        )
                    }
                    }
                    toggle={toggle}

                    isFullWidthBody={true}
                    actionButtonLabel={null}
                    cancelButtonLabel={'Close'}
                    cancelOnClick={isConfirmation ? () => {
                        this.setState({ isConfirmation: false, removedProperties: {} })
                    } : false}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}
                ></FieldModal >}
            </div >
        )

    }
}

export default ViewTableModal;
